import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './store/store'
import 'normalize.css'
import { BrowserRouter } from 'react-router-dom'
import './i18n'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
      {/*<Snowfall*/}
      {/*  color="#e8e8e8"*/}
      {/*  snowflakeCount={600}*/}
      {/*  style={{ position: 'fixed', width: '100vw', height: '100vh' }}*/}
      {/*/>*/}
    </Provider>
  </BrowserRouter>,
)
